require.config({
  baseUrl: '/assets/main/public/scripts',
  waitSeconds: 30,
  paths: {
    'app': 'app.v-phu2hygt00gqsr5qvyakq.js',
    'init': 'init.v-y8ol5jzdblduo2kertzna.js',
    'main': 'main.v-b4y4bajftpghpsodlgrhw2.js',
    'modal': 'modal.v-bat0gzpbh0y7cgrc4nontq.js',
    'scrolltracker': 'scrolltracker.v-bcmmylsavdznbyanprsg.js',
    'togglemodule': 'togglemodule.v-u3z57xsmax8ujgremwykx.js',
    'accordion': 'app/accordion.v-3mq6mocijlhrtfwix5pg.js',
    'ajaxrequesttracker': 'app/ajaxrequesttracker.v-woh1qz5nccuqthxr5wgocq.js',
    'alumni': 'app/alumni.v-m67zkvdlobndgcnrmrjusw.js',
    'capabilities': 'app/capabilities.v-fk8xkx2y5xcduog06u5bg.js',
    'capabilitieslanding': 'app/capabilitieslanding.v-akhzfko2zxufelwuwhdfw.js',
    'careerapplication': 'app/careerapplication.v-banuw73mvfupgflitfiw.js',
    'experiencesearch': 'app/experiencesearch.v-jhecwy4yy7nmszjzsoa5.js',
    'home': 'app/home.v-tdduolnrh3mvdjbytvkz8.js',
    'insight': 'app/insight.v-hqulqki52cjazbpkd58a.js',
    'insightlanding': 'app/insightlanding.v-pgjktxfdumbxnm49yulxw.js',
    'insightlisting': 'app/insightlisting.v-zg8esz49x7fnyvrdgnss6f.js',
    'insightsearch': 'app/insightsearch.v-rmcv4zzsbgyt9nakmjdey2.js',
    'loadmore': 'app/loadmore.v-jxttawqucxoz1wsg1ayuhq.js',
    'mainscript': 'app/mainscript.v-bpapwihdrugn4llc2bp5g.js',
    'navigation': 'app/navigation.v-imvzb3h4coyypiryccvq.js',
    'newslanding': 'app/newslanding.v-jgypolbc7tgrvmply94pa.js',
    'newssearch': 'app/newssearch.v-k1y6ywcf7qriqjyynuqg.js',
    'officedetail': 'app/officedetail.v-klsfsn4zofm3o1fpcaxg.js',
    'professionaldetail': 'app/professionaldetail.v-nzjtddjlkvcgmuspvdsba.js',
    'professionalssearch': 'app/professionalssearch.v-5tjkiwrxtdv8rz4hrzqa3.js',
    'progressbar': 'app/progressbar.v-md1dmihw0qqsydzlwnph7w.js',
    'share': 'app/share.v-rmaeizmukrlhcudswne1g.js',
    'showcaseStories': 'app/showcaseStories.v-6drhue9bm7ubaf3gurwecw.js',
    'tabs': 'app/tabs.v-9j6h1wroxftn34pjlg1nnw.js',
    'ajaxify-html5': 'lib/ajaxify-html5.v-jn4qwnl9aoucvnfkcc0ew.js',
    'angular': 'lib/angular.v-awtkmgt2bhuoigbvwe9oaq.js',
    'imagesLoaded': 'lib/imagesLoaded.min.v-0ezb31mwsloh2pzyysvw.js',
    'jquery.history': 'lib/jquery.history.v-rqelf57qyhoohadbiry4ww.js',
    'jquery.nouislider': 'lib/jquery.nouislider.min.v-rpzrdqckq6g1clg4ml77dg.js',
    'jquery.qtip': 'lib/jquery.qtip.min.v-2au8rgdsx6tadwbs8bbwba.js',
    'jquery.sidr': 'lib/jquery.sidr.min.v-o1amvkvgbh7ck52h2ubnga.js',
    'jquery': 'lib/jquery2.1.0.min.v-gyqfllwk6ynpw96wnpdewa.js',
    'jquery-scrollto': 'lib/jquery-scrollto.v-gvgh4juvvgklqcydujgj3q.js',
    'jquery-ui': 'lib/jquery-ui.min.v-hzod654eqfftgbgikynxw.js',
    'knockout': 'lib/knockout-3.3.0.v-7desipmnowt6pbetiifbg.js',
    'masonry': 'lib/masonry.min.v-xzzvyugbl8ajtgy70eyalg.js',
    'modernizr': 'lib/modernizr2.7.1.min.v-v5zypwejz6xmtrmbtz7ia.js',
    'placeholders': 'lib/placeholders.v-amvp7x7dnpmiscpxk71ta.js',
    'require': 'lib/require.v-eqfzaqrdbt8ecpr24uldag.js',
    'scrollmagic': 'lib/scrollmagic.v-41rrekydayjriih8o0mnea.js',
    'slick': 'lib/slick.min.v-ded432c266322daa6dfd4f.js'
  },
  shim: {
    'masonry': ['jquery'],
    'imagesLoaded': ['jquery'],
    'jquery-scrollto': ['jquery'],
    'jquery.history': ['jquery'],
    'accordion': ['jquery']
  }
});
